import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MasterData } from './master-data';
import { Observable } from 'rxjs';
import { UrlHelperService } from '@ui/global-shared/util/url-helper.service';

@Injectable({
  providedIn: 'root',
})
export class SupplierService {
  private http = inject(HttpClient);
  private urlHelper = inject(UrlHelperService);

  public canUpdate(): Observable<boolean> {
    return this.http.get<boolean>(
      this.urlHelper.prepareApiPath('supplier', 'can-update'),
    );
  }

  public saveMasterData(masterData: MasterData): Observable<void> {
    return this.http.put<void>(
      this.urlHelper.prepareApiPath('supplier', 'masterdata'),
      masterData,
    );
  }

  public getMasterData(): Observable<MasterData> {
    return this.http.get<MasterData>(
      this.urlHelper.prepareApiPath('supplier', 'masterdata'),
    );
  }
}
